import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check, Award, Clock, Shield, Users, Sparkles } from "lucide-react";
import "./AboutIntro.css";
import aboutImg from "../../assets/about-us-car.webp";

const AboutIntro = () => {
  return (
    <section className="about-intro" id="about">
      {/* Background Decor */}
      <div className="about-bg-glow-1"></div>
      <div className="about-bg-glow-2"></div>

      <div className="about-intro-container">
        {/* Left Content */}
        <div className="about-intro-text">
          <div className="about-eyebrow">
            <Sparkles size={14} />
            <span>About Us</span>
            <Sparkles size={14} />
          </div>

          <h2>
            Your Trusted <span>Cab Service</span> Partner
          </h2>

          <p>
            Bhole Cab Service is your trusted travel partner for safe,
            reliable and comfortable transportation across Gujarat. With
            years of experience, we provide professional cab services for
            local travel, outstation trips, airport transfers, corporate
            travel, and more.
          </p>

          <p>
            Our commitment is to deliver smooth journeys with clean cars,
            well-trained drivers and transparent pricing. We pride ourselves
            on our punctuality, safety standards, and customer-first approach.
          </p>

          {/* Features */}
          <div className="about-features">
            <div className="about-feature">
              <Check size={18} />
              <span>Professional Drivers</span>
            </div>
            <div className="about-feature">
              <Shield size={18} />
              <span>Safe & Secure Rides</span>
            </div>
            <div className="about-feature">
              <Clock size={18} />
              <span>On-Time Guarantee</span>
            </div>
            <div className="about-feature">
              <Award size={18} />
              <span>Transparent Pricing</span>
            </div>
          </div>

          {/* CTA Button */}
          <Link to="/about" className="about-cta">
            <span>Learn More</span>
            <ArrowRight size={18} />
          </Link>
        </div>

        {/* Right Image */}
        <div className="about-intro-image">
          <div className="about-image-wrapper">
            <img src={aboutImg} alt="Bhole Cab Service - About us" loading="lazy" />
            <div className="about-image-shimmer"></div>

            {/* Experience Badge - Top Left */}
            <div className="about-experience-badge">
              <span className="experience-number">10+</span>
              <span className="experience-label">Years of Service</span>
            </div>

            {/* Floating Badge - Bottom Right */}
            <div className="about-image-badge">
              <div className="badge-icon">
                <Users size={24} />
              </div>
              <div className="badge-content">
                <span className="badge-number">5000+</span>
                <span className="badge-label">Happy Customers</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;